import Vue from "vue";
import Router from "vue-router";

// 📄 Pages
import Login from "@/views/Login.vue";
import Dashboard from "@/views/Dashboard.vue"; // 🆕 main quick overview
import MonthlyReport from "@/views/MonthlyReport.vue"; // 🧾 detailed monthly report
import CoffeeStock from "@/views/CoffeeStock.vue";
import CashIncome from "@/views/CashIncome.vue";
import Expenses from "@/views/Expenses.vue";

import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/login", name: "Login", component: Login },
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    {
      path: "/monthly-report",
      name: "MonthlyReport",
      component: MonthlyReport,
      meta: { requiresAuth: true },
    },
    {
      path: "/coffee-stock",
      name: "CoffeeStock",
      component: CoffeeStock,
      meta: { requiresAuth: true },
    },
    {
      path: "/cash-income",
      name: "CashIncome",
      component: CashIncome,
      meta: { requiresAuth: true },
    },
    {
      path: "/expenses",
      name: "Expenses",
      component: Expenses,
      meta: { requiresAuth: true },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// ✅ Route protection
router.beforeEach((to, from, next) => {
  const isAuth = store.getters["auth/isAuthenticated"];

  if (to.matched.some((r) => r.meta.requiresAuth) && !isAuth) {
    next("/login");
  } else if (to.path === "/login" && isAuth) {
    next("/");
  } else {
    next();
  }
});

export default router;
